import { render, staticRenderFns } from "./PrivatePurchaseRouter4g.vue?vue&type=template&id=41131b1e&scoped=true&"
import script from "./PrivatePurchaseRouter4g.vue?vue&type=script&lang=js&"
export * from "./PrivatePurchaseRouter4g.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePurchaseRouter4g.vue?vue&type=style&index=0&id=41131b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41131b1e",
  null
  
)

export default component.exports